module.exports = __webpack_public_path__ + "img/na.f1b7ea40.svg";